import type { InferOutput } from 'valibot'
import { array, boolean, nullish, object, optional, picklist, string } from 'valibot'
import { bodytext } from '#shared/utils/solr-fields'

/**
 * Minimal schema for academic article sections as returned by Solr
 */
export const academicArticleSectionSchema = object({
  id: string(),
  title: optional(string()),
  showHeader: optional(boolean()),
  bodytext,
})

export type AcademicArticleSection = InferOutput<typeof academicArticleSectionSchema>

/**
 * Schema for law reference data used in AcademicArticleAside
 */
export const lawReferenceSchema = object({
  id: string(),
  title: nullish(string()),
  // TODO: Fint out why we need to whitelist "legal_commentary_section" here (used in ArticleReferenceItem.vue)
  nodeType: picklist(['section', 'subsection', 'legal_commentary_section']),
  /**
   * For subsections, the bodytext lives directly on the reference. For sections, the bodytext lives on the children.
   * This is a bit inconsistent but reflects the structure of the Solr documents.
   * Additionally, the title will be named "paragraphTitle" for subsections and "title" for sections
   */
  bodytext: nullish(string()),
  paragraphTitle: optional(string()),
  children: optional(array(object({
    id: string(),
    title: nullish(string()),
    bodytext,
    nodeType: nullish(string()),
  }))),
})

export type LawReference = InferOutput<typeof lawReferenceSchema>
